"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : SEPARATOR : STYLES --------------- ++++++++++ */


var _default = {
  separator: {
    margin: (0, _index.replacePXinStringWithEM)('15px auto'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .divider': {
      backgroundColor: function backgroundColor(props) {
        return props.lineColor ? props.lineColor : '#EEF2F6';
      }
    },
    '& .text': {
      margin: function margin(props) {
        return (0, _index.replacePXinStringWithEM)("0 ".concat(props.textMargin ? props.textMargin : '15px'));
      },
      whiteSpace: 'nowrap'
    }
  }
};
exports.default = _default;